import React from "react";
import "./Footer.less";

function Footer() {

    return (
        <footer className="gg-footer" itemScope="itemscope" itemType="http://schema.org/WPFooter">
            <div className="container">
                <div className="gg-paymentss">
                    <img
                        src="../img/sprite-payments-logo_2.png"
                        alt="Payments" />
                </div>
                <div className="gg-footer_copyrights">
                    <p className="copyright_text">&copy; 2020 GG.BET. All rights reserved. gg.bet is operated by Brivio
                        Limited, a company registered in the Republic of Cyprus, with its principal place of business
                        at: Office 102, 12A Lekorpouzier, Limassol, Cyprus; Registration number: HE315596; VAT number
                        10315596B. All gambling services are licensed by Invicta Networks (License No. 8048/JAZ) N.V.,
                        Address: Heelsumstraat 51, E-Commerce Park, Curaçao, P.O. Box 422, Netherlands Antilles,
                        Registration number: 123787, which is a parent company of Brivio Limited.</p>
                    <p className="copyright_icons">
                        <img
                            src="../img/copyright_icon1.png"
                            alt="copyright_icon1"
                        />
                        <img
                            src="../img/copyright_icon2.png"
                            alt="copyright_icon2"
                        />
                        <img
                            src="../img/copyright_icon3.png"
                            alt="copyright_icon3"
                        />
                        <img
                            src="../img/copyright_icon4.png"
                            alt="copyright_icon4"
                        />
                        <img
                            src="../img/copyright_icon5.png"
                            alt="copyright_icon5"
                        />
                    </p>
                </div>
            </div>
            <meta itemProp="copyrightYear" content="2020"/>
        </footer>
    )
}

export default Footer;